// extracted by mini-css-extract-plugin
export var columnList = "columns-list-module--columnList--8b44d";
export var columnList1 = "columns-list-module--columnList1--1cc0b";
export var columnList2 = "columns-list-module--columnList2--72690 columns-list-module--columnList--8b44d";